import { ReactNode, forwardRef } from 'react';
import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';

export interface Filter {
  key: string;
  label: string;
  count: number;
}

export type onFilterChange = (filter: Filter) => void;

type PageFilterRootTypeMap = BaseTypeMap<'div', { children: ReactNode }>;

export type PageFilterRootProps = ComponentProps<PageFilterRootTypeMap>;

export const PageFilterRoot: Component<PageFilterRootTypeMap> = forwardRef(
  function PageFilter({ children, ...props }, ref) {
    return (
      <Box ref={ref} className="flex, flex-wrap" {...props}>
        {children}
      </Box>
    );
  }
);
